import { render, staticRenderFns } from "./Reviews3.vue?vue&type=template&id=56fa1b72&scoped=true"
import script from "./Reviews3.vue?vue&type=script&lang=ts"
export * from "./Reviews3.vue?vue&type=script&lang=ts"
import style0 from "./Reviews3.vue?vue&type=style&index=0&id=56fa1b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa1b72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VContainer,VImg,VRow})
